(() => {
  'use strict';

  /* PN5A_MENTOR_SESSIONS_CONTROLLER */

  const root =
    document.querySelector(
      '[data-pnmd-dashboard]'
    );

  if (!root) return;


  let started =
    false;

  let mentorProfile =
    null;

  let bookings =
    [];


  const esc =
    value =>
      String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');


  async function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB
      .request(
        `rpc/${name}`,
        '',
        {
          method:'POST',
          body
        }
      );

  }


  function dateText(
    value
  ) {

    const date =
      new Date(value);


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return '—';
    }


    return new Intl.DateTimeFormat(
      undefined,
      {
        weekday:'short',
        day:'numeric',
        month:'short',
        hour:'numeric',
        minute:'2-digit'
      }
    ).format(date);

  }


  function duration(
    booking
  ) {

    const start =
      new Date(
        booking.starts_at
      ).getTime();

    const end =
      new Date(
        booking.ends_at
      ).getTime();


    if (
      !Number.isFinite(start) ||
      !Number.isFinite(end)
    ) {
      return null;
    }


    return Math.round(
      (end - start) /
      60000
    );

  }


  function statusText(
    status
  ) {

    return String(
      status || ''
    )
      .replaceAll(
        '_',
        ' '
      );

  }


  function joinState(
    booking
  ) {

    if (
      booking.status !==
      'confirmed'
    ) {

      return {
        enabled:false,
        label:'Join unavailable'
      };

    }


    if (
      booking.has_meet_link !==
      true
    ) {

      return {
        enabled:false,
        label:'Add Meet link first'
      };

    }


    const now =
      Date.now();

    const starts =
      new Date(
        booking.starts_at
      ).getTime();

    const ends =
      new Date(
        booking.ends_at
      ).getTime();


    if (
      now <
      starts - 5 * 60 * 1000
    ) {

      return {
        enabled:false,
        label:'Join now'
      };

    }


    if (
      now >
      ends + 2 * 60 * 60 * 1000
    ) {

      return {
        enabled:false,
        label:'Join window ended'
      };

    }


    return {
      enabled:true,
      label:'Join Session'
    };

  }


  function canCancel(
    booking
  ) {

    return (
      booking.status ===
        'confirmed'
      &&
      new Date(
        booking.starts_at
      ).getTime() >
      Date.now()
    );

  }


  /* PN_SESSION_VERIFICATION_UI_V1 */

  function completionState(
    booking
  ) {

    if (
      booking.booking_type ===
      'compare_live'
    ) {

      const info = booking._pnCompareParticipation;
      const midpoint = new Date(booking.starts_at).getTime()
        + (new Date(booking.ends_at).getTime()
        - new Date(booking.starts_at).getTime()) / 2;
      const legacyReview = info?.legacy_review_required === true;
      const done = info?.my_completed === true;
      const waitingForJoin = info?.my_joined !== true;
      const waitingForStudent = info?.student_joined !== true;
      const waitingForMidpoint = Date.now() < midpoint;
      const allowed = booking.status === 'confirmed'
        && !!info && !legacyReview && !done && !waitingForJoin
        && !waitingForStudent && !waitingForMidpoint;
      return {
        enabled:allowed,
        label:legacyReview ? 'Admin review required'
          : done ? 'Your completion recorded'
          : !info ? 'Checking session status'
          : waitingForJoin ? 'Join session first'
          : waitingForStudent ? 'Waiting for student'
          : waitingForMidpoint ? 'Waiting for 50% duration'
          : 'Complete Session',
        detail:legacyReview ? 'Historical Compare booking; admin must review attendance and payout.'
          : done ? 'Waiting for the other mentor to complete.'
          : allowed ? 'Both Join actions recorded; you may complete your part.'
          : 'A confirmed paid session needs individual participation.'
      };

    }


    if (
      booking.status !==
      'confirmed'
    ) {

      return {
        enabled:false,
        label:'Complete Session',
        detail:'Session is not confirmed.'
      };

    }


    const now =
      Date.now();

    const start =
      new Date(
        booking.starts_at
      ).getTime();

    const end =
      new Date(
        booking.ends_at
      ).getTime();

    const eligible =
      booking.completion_eligible_at
        ? new Date(
            booking.completion_eligible_at
          ).getTime()
        : start +
          (
            end -
            start
          ) / 2;


    if (
      !booking.mentor_joined_at
    ) {

      if (
        now > end &&
        booking.student_joined_at
      ) {

        return {
          enabled:false,
          label:'Mentor did not join',
          detail:'Possible mentor no-show · admin review required.'
        };

      }

      return {
        enabled:false,
        label:'Join session first',
        detail:'Your Join Session action has not been recorded.'
      };

    }


    if (
      !booking.student_joined_at
    ) {

      if (
        now > end
      ) {

        return {
          enabled:false,
          label:'Student did not join',
          detail:'Possible student no-show · admin review required.'
        };

      }

      return {
        enabled:false,
        label:'Waiting for student',
        detail:'Student has not joined yet.'
      };

    }


    if (
      now < eligible
    ) {

      const seconds =
        Math.max(
          0,
          Math.ceil(
            (
              eligible -
              now
            ) /
            1000
          )
        );

      const minutes =
        Math.floor(
          seconds /
          60
        );

      const rest =
        seconds % 60;

      return {
        enabled:false,
        label:
          minutes
            ? `Complete in ${minutes}m ${rest}s`
            : `Complete in ${rest}s`,
        detail:'Both joined · waiting for the 50% session threshold.'
      };

    }


    return {
      enabled:true,
      label:'Complete Session',
      detail:'Both joined · completion requirement reached.'
    };

  }


  function canComplete(
    booking
  ) {

    return completionState(
      booking
    ).enabled;

  }


  function applySessionVerificationUI() {

    bookings.forEach(
      booking => {

        if (
          booking.booking_type !==
          'single'
        ) {
          return;
        }


        const card =
          document.querySelector(
            `[data-pn5-mentor-booking="${CSS.escape(
              booking.id
            )}"]`
          );

        if (!card) {
          return;
        }


        const state =
          completionState(
            booking
          );


        const button =
          card.querySelector(
            '[data-pn5-mentor-complete]'
          );


        if (button) {

          button.disabled =
            !state.enabled;

          button.textContent =
            state.label;

        }


        let box =
          card.querySelector(
            '[data-pn5-session-verification]'
          );


        if (!box) {

          box =
            document.createElement(
              'div'
            );

          box.className =
            'pn5-session-verification';

          box.setAttribute(
            'data-pn5-session-verification',
            ''
          );


          const actions =
            card.querySelector(
              '.pn5-mentor-session__actions'
            );


          if (actions) {

            card.insertBefore(
              box,
              actions
            );

          } else {

            card.appendChild(
              box
            );

          }

        }


        const now =
          Date.now();

        const end =
          new Date(
            booking.ends_at
          ).getTime();

        const eligible =
          booking.completion_eligible_at
            ? new Date(
                booking.completion_eligible_at
              ).getTime()
            : new Date(
                booking.starts_at
              ).getTime()
              +
              (
                end -
                new Date(
                  booking.starts_at
                ).getTime()
              ) / 2;


        let outcome =
          'Awaiting session';


        if (
          booking.status ===
          'completed'
        ) {

          outcome =
            'Completed successfully';

        }
        else if (
          booking.status ===
          'cancelled'
        ) {

          outcome =
            'Session cancelled';

        }
        else if (
          now > end &&
          booking.mentor_joined_at &&
          !booking.student_joined_at
        ) {

          outcome =
            'Student no-show · Review required';

        }
        else if (
          now > end &&
          !booking.mentor_joined_at &&
          booking.student_joined_at
        ) {

          outcome =
            'Mentor no-show · Review required';

        }
        else if (
          now > end &&
          !booking.mentor_joined_at &&
          !booking.student_joined_at
        ) {

          outcome =
            'No join activity · Review required';

        }
        else if (
          now > end &&
          booking.mentor_joined_at &&
          booking.student_joined_at
        ) {

          outcome =
            'Completion overdue · Review required';

        }
        else if (
          booking.mentor_joined_at &&
          booking.student_joined_at &&
          now >= eligible
        ) {

          outcome =
            'Ready to complete';

        }
        else if (
          booking.mentor_joined_at &&
          booking.student_joined_at
        ) {

          outcome =
            'Session in progress';

        }
        else if (
          booking.mentor_joined_at
        ) {

          outcome =
            'Mentor joined · Waiting for student';

        }
        else if (
          booking.student_joined_at
        ) {

          outcome =
            'Student joined · Waiting for mentor';

        }


        box.innerHTML = `
          <div class="pn5-session-verification__head">
            SESSION VERIFICATION
          </div>

          <div class="pn5-session-verification__checks">

            <span>
              ${booking.mentor_joined_at ? '✓' : '○'}
              Mentor joined
            </span>

            <span>
              ${booking.student_joined_at ? '✓' : '○'}
              Student joined
            </span>

            <span>
              ${now >= eligible ? '✓' : '○'}
              50% reached
            </span>

          </div>

          <strong>
            ${esc(outcome)}
          </strong>

          <small>
            ${esc(state.detail)}
          </small>
        `;

      }
    );

  }


  function bookingCard(
    booking,
    history = false
  ) {

    const join =
      joinState(
        booking
      );

    const minutes =
      duration(
        booking
      );


    return `
      <article
        class="pn5-mentor-session"
        data-pn5-mentor-booking="${esc(
          booking.id
        )}"
      >

        <div class="pn5-mentor-session__head">

          <div>
            <small>
              ${
                history
                  ? (
                      booking.booking_type ===
                      'compare_live'
                        ? 'COMPARE LIVE HISTORY'
                        : 'SESSION HISTORY'
                    )
                  : (
                      booking.booking_type ===
                      'compare_live'
                        ? 'COMPARE LIVE'
                        : 'STUDENT SESSION'
                    )
              }
            </small>

            <h4>
              ${esc(
                booking.student_name ||
                'Student'
              )}
            </h4>

            ${
              booking.student_email
                ? `
                  <p>
                    ${esc(
                      booking.student_email
                    )}
                  </p>
                `
                : ''
            }


            ${
              booking.booking_type ===
                'compare_live' &&
              booking.mentor_names
                ? `
                  <p>
                    Compare Live ·
                    ${esc(
                      booking.mentor_names
                    )}
                  </p>
                `
                : ''
            }
          </div>

          <span
            class="pn5-mentor-status"
            data-status="${esc(
              booking.status
            )}"
          >
            ${esc(
              statusText(
                booking.status
              )
            )}
          </span>

        </div>


        <div class="pn5-mentor-session__meta">

          <span>
            ${esc(
              dateText(
                booking.starts_at
              )
            )}
          </span>

          ${
            minutes
              ? `
                <span>
                  ${minutes} min
                </span>
              `
              : ''
          }

        </div>


        ${
          booking.booking_type === 'compare_live' &&
          booking._pnCompareParticipation?.legacy_review_required === true
            ? `<div class="pn5-session-verification" role="status">
                 <strong>Admin review required</strong>
                 <small>Historical Compare Live session. Attendance and mentor payout need admin verification.</small>
               </div>`
            : ''
        }

        ${
          booking.booking_type === 'compare_live' &&
          booking._pnCompareParticipation?.my_completed &&
          booking.status === 'confirmed'
            ? `<div class="pn5-session-verification">
                 ✓ Your completion recorded · Waiting for the other mentor
               </div>`
            : ''
        }

        ${booking._pnCompensation === true
          ? `<p class="pn5-mentor-session__notes">Free compensation session · no additional payout</p>`
          : ''}
        ${
          booking.student_notes
            ? `
              <p class="pn5-mentor-session__notes">
                ${esc(
                  booking.student_notes
                )}
              </p>
            `
            : ''
        }


        ${
          history && !(booking.booking_type === 'compare_live'
              && canComplete(booking))
            ? ''
            : `
              <div class="pn5-mentor-session__actions">

                <button
                  type="button"
                  class="pn5-mentor-action pn5-mentor-action--primary"
                  data-pn5-mentor-join="${esc(
                    booking.id
                  )}"
                  ${
                    join.enabled
                      ? ''
                      : 'disabled'
                  }
                >
                  ${esc(
                    join.label
                  )}
                </button>

                ${
                  canComplete(
                    booking
                  )
                    ? `
                      <button
                        type="button"
                        class="pn5-mentor-action"
                        data-pn5-mentor-complete="${esc(
                          booking.id
                        )}"
                      >
                        Mark Completed
                      </button>
                    `
                    : ''
                }

                ${
                  canCancel(
                    booking
                  )
                    ? `
                      <button
                        type="button"
                        class="pn5-mentor-action"
                        data-pn5-mentor-cancel="${esc(
                          booking.id
                        )}"
                      >
                        Cancel Session
                      </button>
                    `
                    : ''
                }

              </div>
            `
        }

      </article>
    `;

  }


  function panelMarkup() {

    return `
      <div class="pn5-mentor-sessions__heading">

        <div>
          <span>SESSIONS</span>

          <h2>
            Your mentor sessions
          </h2>

          <p>
            Upcoming conversations, session history
            and your permanent Google Meet room.
          </p>
        </div>

      </div>


      <form
        class="pn5-meet-card"
        data-pn5-meet-form
      >

        <div>
          <small>
            PERMANENT GOOGLE MEET LINK
          </small>

          <strong>
            One Meet room for all 1:1 sessions
          </strong>

          <p>
            PeerNest only releases this link to the booked
            student during the secure join window.
          </p>
        </div>


        <div class="pn5-meet-card__controls">

          <input
            type="url"
            data-pn5-meet-input
            placeholder="https://meet.google.com/xxx-xxxx-xxx"
          >

          <button
            type="submit"
            class="pn5-mentor-action pn5-mentor-action--primary"
            data-pn5-meet-save
          >
            Save Meet Link
          </button>

        </div>


        <small
          class="pn5-meet-card__message"
          data-pn5-meet-message
        ></small>

      </form>


      <div class="pn5-mentor-session-grid">

        <section>

          <div class="pn5-mentor-session-grid__title">
            <small>UPCOMING</small>
            <h3>Upcoming sessions</h3>
          </div>

          <div
            data-pn5-mentor-upcoming
          ></div>

        </section>


        <section>

          <div class="pn5-mentor-session-grid__title">
            <small>HISTORY</small>
            <h3>Past sessions</h3>
          </div>

          <div
            data-pn5-mentor-history
          ></div>

        </section>

      </div>
    `;

  }


  function mount() {

    const availability =
      root.querySelector(
        '[data-pnmd-availability]'
      );

    const availabilityNav =
      root.querySelector(
        '[data-pnmd-availability-nav]'
      );


    if (
      !availability ||
      !availabilityNav
    ) {
      return null;
    }


    let panel =
      root.querySelector(
        '[data-pn5-mentor-sessions]'
      );


    if (!panel) {

      panel =
        document.createElement(
          'section'
        );

      panel.setAttribute(
        'data-pn5-mentor-sessions',
        ''
      );

      panel.setAttribute(
        'id',
        'sessions'
      );

      panel.className =
        'pn5-mentor-sessions';

      panel.hidden =
        true;

      panel.innerHTML =
        panelMarkup();


      availability.insertAdjacentElement(
        'afterend',
        panel
      );

    }


    let sessionsNav =
      root.querySelector(
        '[data-pn5-sessions-nav]'
      );


    if (!sessionsNav) {

      sessionsNav =
        availabilityNav
          .cloneNode(
            true
          );


      sessionsNav.removeAttribute(
        'data-pnmd-availability-nav'
      );

      sessionsNav.setAttribute(
        'data-pn5-sessions-nav',
        ''
      );

      sessionsNav.classList
        .remove(
          'is-active'
        );

      sessionsNav.textContent =
        'Sessions';


      if (
        sessionsNav.tagName ===
        'A'
      ) {

        sessionsNav.setAttribute(
          'href',
          '#sessions'
        );

      }


      availabilityNav
        .insertAdjacentElement(
          'afterend',
          sessionsNav
        );

    }


    const navParent =
      availabilityNav.parentElement;


    /*
     * PN5A_SINGLE_MY_SESSIONS_NAV
     *
     * The Mentor dashboard already had an older placeholder
     * "My Sessions" navigation item. Phase 5A added the real
     * sessions workspace separately.
     *
     * Remove that old placeholder navigation item and keep
     * the working Phase 5A item as the single My Sessions entry.
     */

    sessionsNav.textContent =
      'My Sessions';


    let oldSessionsWasActive =
      false;


    if (navParent) {

      const oldSessionsNav =
        Array.from(
          navParent.querySelectorAll(
            'a,button'
          )
        )
          .find(
            item => {

              if (
                item === sessionsNav ||
                item === availabilityNav ||
                item.hasAttribute(
                  'data-pn5-sessions-nav'
                )
              ) {
                return false;
              }


              const text =
                String(
                  item.textContent ||
                  ''
                )
                  .replace(
                    /\\s+/g,
                    ' '
                  )
                  .trim()
                  .toLowerCase();


              return text.startsWith(
                'my sessions'
              );

            }
          );


      if (oldSessionsNav) {

        oldSessionsWasActive =
          oldSessionsNav.classList
            .contains(
              'is-active'
            );


        oldSessionsNav.remove();

      }

    }


    sessionsNav.addEventListener(
      'click',
      event => {

        event.preventDefault();


        /*
         * Reuse the existing working Availability navigation
         * first so the current Mentor dashboard controls which
         * main workspace is active.
         */
        availabilityNav.click();


        queueMicrotask(
          () => {

            availability.hidden =
              true;

            panel.hidden =
              false;

            availabilityNav.classList
              .remove(
                'is-active'
              );

            sessionsNav.classList
              .add(
                'is-active'
              );


            loadBookings();

          }
        );

      }
    );


    if (navParent) {

      navParent.addEventListener(
        'click',
        event => {

          const target =
            event.target.closest(
              'a,button'
            );


          if (
            !target ||
            target ===
            sessionsNav
          ) {
            return;
          }


          panel.hidden =
            true;

          sessionsNav.classList
            .remove(
              'is-active'
            );

        }
      );

    }


    /*
     * If the old placeholder My Sessions workspace was the
     * active dashboard view, immediately open the real Phase 5A
     * My Sessions workspace instead.
     */

    if (
      oldSessionsWasActive ||
      window.location.hash ===
        '#sessions'
    ) {

      queueMicrotask(
        () => {
          sessionsNav.click();
        }
      );

    }


    return panel;

  }


  /* PN5_MENTOR_HISTORY_POPUP_V1 */

  function closeMentorHistoryPopup() {

    document
      .querySelector(
        '[data-pn5-mentor-history-dialog]'
      )
      ?.remove();

    document.body
      .classList
      .remove(
        'pn5-mentor-history-open'
      );

  }


  /* PN_MENTOR_SESSION_PERIOD_CLIENT_V1
   * Display grouping only. An elapsed confirmed session is history,
   * not an "Upcoming" session. Never update a booking status here.
   */
  function isPastSession(booking) {
    const status = String(booking?.status || '').toLowerCase();
    if (['completed', 'cancelled', 'rejected', 'refunded'].includes(status)) {
      return true;
    }
    if (String(booking?.session_period || '').toLowerCase() === 'past') {
      return true;
    }
    const endMs = Date.parse(booking?.ends_at || '');
    return Number.isFinite(endMs) && endMs <= Date.now();
  }


  function mentorHistoryRows() {



    return bookings
      .filter(booking => isPastSession(booking))
      .sort(
        (a,b) =>
          new Date(
            b.starts_at
          ) -
          new Date(
            a.starts_at
          )
      );

  }


  function openMentorHistoryPopup() {

    closeMentorHistoryPopup();


    const history =
      mentorHistoryRows();


    const dialog =
      document.createElement(
        'div'
      );


    dialog.className =
      'pn5-mentor-history-dialog';

    dialog.setAttribute(
      'data-pn5-mentor-history-dialog',
      ''
    );


    dialog.innerHTML = `
      <div
        class="pn5-mentor-history-dialog__backdrop"
        data-pn5-mentor-history-close
      ></div>

      <section
        class="pn5-mentor-history-dialog__panel"
        role="dialog"
        aria-modal="true"
        aria-label="Mentor session history"
      >

        <div class="pn5-mentor-history-dialog__head">

          <div>

            <span>
              SESSION ARCHIVE
            </span>

            <h2>
              Past sessions
            </h2>

            <p>
              ${history.length}
              past session${history.length === 1 ? '' : 's'}
            </p>

          </div>


          <button
            type="button"
            class="pn5-mentor-history-dialog__close"
            data-pn5-mentor-history-close
          >
            ×
          </button>

        </div>


        <div class="pn5-mentor-history-dialog__body">

          ${
            history.length
              ? history
                  .map(
                    booking =>
                      bookingCard(
                        booking,
                        true
                      )
                  )
                  .join('')
              : `
                  <div class="pn5-mentor-empty">
                    <strong>
                      No session history yet.
                    </strong>
                  </div>
                `
          }

        </div>

      </section>
    `;


    document.body
      .appendChild(
        dialog
      );


    document.body
      .classList
      .add(
        'pn5-mentor-history-open'
      );


    dialog.addEventListener(
      'click',
      event => {

        if (
          event.target.closest(
            '[data-pn5-mentor-history-close]'
          )
        ) {

          closeMentorHistoryPopup();

        }

      }
    );

  }


  function render() {

    const panel =
      root.querySelector(
        '[data-pn5-mentor-sessions]'
      );


    if (!panel) return;


    const upcomingNode =
      panel.querySelector(
        '[data-pn5-mentor-upcoming]'
      );

    const historyNode =
      panel.querySelector(
        '[data-pn5-mentor-history]'
      );



    const upcoming =
      bookings
        .filter(booking => !isPastSession(booking))
        .sort(
          (a,b) =>
            new Date(
              a.starts_at
            ) -
            new Date(
              b.starts_at
            )
        );


    const history =
      bookings
        .filter(booking => isPastSession(booking))
        .sort(
          (a,b) =>
            new Date(
              b.starts_at
            ) -
            new Date(
              a.starts_at
            )
        );


    upcomingNode.innerHTML =
      upcoming.length
        ? upcoming
            .map(
              booking =>
                bookingCard(
                  booking
                )
            )
            .join('')
        : `
          <div class="pn5-mentor-empty">
            <strong>
              No upcoming sessions.
            </strong>

            <p>
              New student bookings will appear here.
            </p>
          </div>
        `;


    const visibleHistory =
      history.slice(
        0,
        3
      );


    historyNode.innerHTML =
      history.length
        ? `
            ${visibleHistory
              .map(
                booking =>
                  bookingCard(
                    booking,
                    true
                  )
              )
              .join('')}

            ${
              history.length > 3
                ? `
                  <div class="pn5-mentor-history-more">

                    <button
                      type="button"
                      class="pn5-mentor-history-more__button"
                      data-pn5-mentor-history-open
                    >

                      <div>
                        <strong>
                          View all history
                        </strong>

                        <small>
                          ${history.length - 3}
                          more session${history.length - 3 === 1 ? '' : 's'}
                        </small>
                      </div>

                      <span>
                        →
                      </span>

                    </button>

                  </div>
                `
                : ''
            }
          `
        : `
          <div class="pn5-mentor-empty">
            <strong>
              No session history yet.
            </strong>
          </div>
        `;


    /* PN5A_SHARED_RESCHEDULE_MENTOR_HOOK */

    window.PeerNestReschedule
      ?.attachMentorButtons(
        upcomingNode,
        upcoming.filter(
          booking =>
            booking.booking_type ===
            'single'
        )
      );

  }


  /* PN6_COMPARE_LIVE_DASHBOARD */

  async function loadBookings() {

    const result =
      await rpc(
        'get_my_mentor_bookings'
      );


    bookings =
      Array.isArray(
        result
      )
        ? result
        : [];

    // PN PASS2: merge zero-payment replacement bookings independently of
    // the legacy paid-session RPC; preserve all normal/Compare bookings.
    try {
      const replacements = await rpc('pn_mentor_list_my_compensations_v1');
      const replacementList = Array.isArray(replacements) ? replacements : [];
      const byId = new Map(bookings.map(item => [String(item.id), item]));
      replacementList.forEach(item => {
        const id = String(item?.id || '');
        if (!id) return;
        if (byId.has(id)) {
          byId.get(id)._pnCompensation = true;
        } else {
          item._pnCompensation = true;
          bookings.push(item);
          byId.set(id,item);
        }
      });
      // Existing ID RPC also marks cancelled historic replacements if present.
      const replacementIds = await rpc('pn_get_my_compensation_booking_ids_v1');
      const ids = new Set(Array.isArray(replacementIds) ? replacementIds.map(String) : []);
      bookings.forEach(item => { if (ids.has(String(item.id))) item._pnCompensation = true; });
    } catch (error) {
      // Fail closed for compensation-specific actions. Normal sessions still load.
      console.warn('[PeerNest] free compensation listing unavailable',error);
    }

    // Compare: load the current mentor's own Join/Complete state.
    // This RPC is read-only and does not change existing 1:1 sessions.
    await Promise.allSettled(
      bookings.filter(booking => booking.booking_type === 'compare_live' && booking.status === 'confirmed')
        .map(async booking => {
          try {
            booking._pnCompareParticipation = await rpc(
              'pn_compare_get_my_participation_v1',
              {p_booking_id:booking.id}
            );
          } catch (error) {
            booking._pnCompareParticipation = null;
            console.warn('Compare participation unavailable',error);
          }
        })
    );

    render();

    applySessionVerificationUI();

  }


  async function join(
    bookingId
  ) {

    const popup =
      window.open(
        '',
        '_blank'
      );


    if (popup) {
      popup.opener =
        null;
    }


    try {

      const result =
        await rpc(
          'get_my_session_join_url',
          {
            p_booking_id:
              bookingId
          }
        );


      if (
        result?.allowed !==
        true ||
        !result?.url
      ) {

        throw new Error(
          result?.reason ||
          'This session cannot be joined yet.'
        );

      }


      if (popup) {

        popup.location
          .replace(
            result.url
          );

      }
      else {

        window.open(
          result.url,
          '_blank',
          'noopener,noreferrer'
        );

      }

      // The secure Compare Join RPC just recorded this mentor's Join click.
      // Update dashboard state without delaying the opened Meet tab.
      if (bookings.some(item => String(item.id) === String(bookingId)
          && item.booking_type === 'compare_live')) {
        loadBookings().catch(() => {});
      }

    }
    catch (error) {

      popup?.close();


      window.alert(
        error?.message ||
        'Could not open this session.'
      );

    }

  }


  async function updateStatus(
    bookingId,
    newStatus
  ) {

    const booking =
      bookings.find(
        item =>
          String(item.id) ===
          String(bookingId)
      );


    const compareLive =
      booking?.booking_type ===
      'compare_live';


    if (
      newStatus ===
        'cancelled' &&
      !window.confirm(
        compareLive
          ? 'Cancel this Compare Live session for the student and both mentors?'
          : 'Cancel this mentor session?'
      )
    ) {
      return;
    }


    try {

      if (newStatus === 'completed' && booking?._pnCompensation === true) {
        await rpc('pn_complete_compensation_v1', {p_booking_id: bookingId});
      } else {
        await rpc(
          'mentor_update_booking_status',
          {
            p_booking_id:
              bookingId,

            p_new_status:
              newStatus,

            p_reason:
              null
          }
        );
      }


      await loadBookings();

    }
    catch (error) {

      window.alert(
        error?.message ||
        'Could not update the session.'
      );

    }

  }


  async function saveMeet(
    form
  ) {

    const input =
      form.querySelector(
        '[data-pn5-meet-input]'
      );

    const button =
      form.querySelector(
        '[data-pn5-meet-save]'
      );

    const message =
      form.querySelector(
        '[data-pn5-meet-message]'
      );


    const value =
      String(
        input.value || ''
      ).trim();


    button.disabled =
      true;

    message.textContent =
      'Saving…';


    try {

      const result =
        await rpc(
          'set_my_default_meet_url',
          {
            p_meet_url:
              value
          }
        );


      mentorProfile = {
        ...mentorProfile,
        default_meet_url:
          result?.default_meet_url ||
          ''
      };


      input.value =
        mentorProfile
          .default_meet_url;


      message.textContent =
        result?.configured
          ? 'Meet link saved.'
          : 'Meet link cleared.';


      /*
       * Reload so has_meet_link comes from the
       * secure booking RPC, not from local assumptions.
       */
      await loadBookings();

    }
    catch (error) {

      message.textContent =
        error?.message ||
        'Could not save the Meet link.';

    }
    finally {

      button.disabled =
        false;

    }

  }


  function bind(
    panel
  ) {

    panel.addEventListener(
      'submit',
      event => {

        const form =
          event.target.closest(
            '[data-pn5-meet-form]'
          );


        if (!form) return;


        event.preventDefault();

        saveMeet(
          form
        );

      }
    );


    panel.addEventListener(
      'click',
      event => {

        const historyButton =
          event.target.closest(
            '[data-pn5-mentor-history-open]'
          );


        if (historyButton) {

          openMentorHistoryPopup();

          return;

        }


        const joinButton =
          event.target.closest(
            '[data-pn5-mentor-join]'
          );


        if (
          joinButton &&
          !joinButton.disabled
        ) {

          join(
            joinButton.dataset
              .pn5MentorJoin
          );

          return;

        }


        const completeButton =
          event.target.closest(
            '[data-pn5-mentor-complete]'
          );


        if (completeButton) {

          updateStatus(
            completeButton.dataset
              .pn5MentorComplete,
            'completed'
          );

          return;

        }


        const cancelButton =
          event.target.closest(
            '[data-pn5-mentor-cancel]'
          );


        if (cancelButton) {

          updateStatus(
            cancelButton.dataset
              .pn5MentorCancel,
            'cancelled'
          );

        }

      }
    );

  }


  document.addEventListener(
    'keydown',
    event => {

      if (
        event.key ===
        'Escape'
      ) {

        closeMentorHistoryPopup();

      }

    }
  );


  async function init() {

    if (
      started ||
      !window.PeerNestDB
    ) {
      return;
    }


    try {

      const profile =
        await window.PeerNestDB
          .getMyProfile();


      if (
        !profile ||
        profile.role !==
          'mentor' ||
        profile.account_status !==
          'active'
      ) {
        return;
      }


      mentorProfile =
        await window.PeerNestDB
          .getMyMentorProfile();


      if (
        !mentorProfile ||
        mentorProfile.onboarding_completed !==
          true
      ) {
        return;
      }


      const panel =
        mount();


      if (!panel) {

        console.error(
          '[PeerNest] Mentor session mount hooks missing.'
        );

        return;

      }


      started =
        true;


      const input =
        panel.querySelector(
          '[data-pn5-meet-input]'
        );


      input.value =
        mentorProfile
          .default_meet_url ||
        '';


      bind(
        panel
      );

      await loadBookings();


      window.setInterval(
        render,
        60000
      );

    }
    catch (error) {

      console.error(
        '[PeerNest] Mentor sessions:',
        error
      );

    }

  }


  document.addEventListener(
    'peernest:dashboard-ready',
    event => {

      if (
        event?.detail?.profile?.role ===
        'mentor'
      ) {
        init();
      }

    }
  );


  if (window.PeerNestDB) {

    init();

  }
  else {

    document.addEventListener(
      'peernest:supabase-ready',
      init,
      {
        once:true
      }
    );

  }


  window.setInterval(
    () => {

      if (
        Array.isArray(bookings) &&
        bookings.length
      ) {

        applySessionVerificationUI();

      }

    },
    15000
  );


})();
